import { organisationConstants } from '../../_constants/organisation.constants';

const initialState = {
    orgUploadError: null, // Set the initial value to null
    orgUploadLoading: true,
    orgUploadSuccess: '',
    orgImageLoad: false
}

export function orgImageUpload(state = initialState, action) {
    switch (action.type) {
        case organisationConstants.ORG_REQUEST_UPLOAD:
            return {
                orgUploadError: null, // Reset the error to null when a new request is made
                orgUploadLoading: true,
                orgUploadSuccess: '',
                orgImageLoad: true
            }
        case organisationConstants.ORG_RESPONSE_UPLOAD:
            return {
                orgUploadError: null, // Reset the error to null when a successful response is received
                orgUploadLoading: false,
                orgUploadSuccess: action.imgUpload,
                orgImageLoad: false
            }
        case organisationConstants.ORG_ERROR_UPLOAD:
            return {
                orgUploadError: action.error, // Store the error object received from the API
                orgUploadLoading: false,
                orgUploadSuccess: '',
                orgImageLoad: false
            }
        default:
            return state;
    }
}


// WEBPACK FOOTER //
// ./src/_reducers/organisation/imageUpload.reducer.js